<h4 *ngIf="multimediaList.title">{{ multimediaList.title }}</h4>
<div
  class="multimedia-list"
  *ngIf="multimediaList && multimediaList.items"
  [ngClass]="{
    'multimedia-list--background-color': backgroundColor,
  }"
>
  <div
    *ngFor="let item of multimediaList.items"
    class="multimedia-list-item"
    [style.backgroundColor]="multimediaList.backgroundColor"
  >
    <span class="left-icon">
      <hdi-icon *ngIf="item.leftIcon" [iconName]="item.leftIcon"></hdi-icon>
      <p [title]="item.label">
        <hdi-badge
          *ngIf="item.badge"
          [label]="item.badge | capitalize"
          [type]="BadgeType.CAPSULE"
          [size]="Sizes.XSMALL"
        ></hdi-badge
        >{{ item.label }}
      </p>
    </span>
    <span
      class="right-icons"
      *ngIf="item.rightIcons && item.rightIcons.length > 0"
    >
      <hdi-button
        *ngFor="let icon of item.rightIcons; let i = index"
        [type]="ButtonType.CHILDREN"
        (pointerenter)="icon.tooltip ? openTooltip(icon.tooltip) : null"
        (pointerleave)="icon.tooltip ? closeTooltip() : null"
        (click)="icon.type === 'circle-play' ? openModal($event, icon) : null"
        (keydown)="icon.type === 'circle-play' ? openModal($event, icon) : null"
      >
        <!-- If the icon type is not 'down-to-line', then it is a link. And it doesn't have a download attribute -->
        <!-- Angular Router Link (Internal Link)-->
        <a
          *ngIf="
            icon.type !== 'down-to-line' &&
            icon.type !== 'eye' &&
            icon.type !== 'envelope' &&
            icon.type !== 'phone' &&
            (icon.target === '_self' || !icon.target)
          "
          [routerLink]="icon.type !== 'link' ? '/' + icon.href : null"
          [attr.target]="icon.target ?? '_self'"
          [title]="icon.title"
          (click)="icon.type === 'link' ? copyToClipboard(icon, $event) : null"
          (keydown)="
            icon.type === 'link' ? copyToClipboard(icon, $event) : null
          "
        >
          <hdi-icon
            [iconPrefix]="'far'"
            [iconName]="getIconName(icon.type)"
            [size]="Sizes.SMALL"
            [color]="Colors.BLACK"
          ></hdi-icon>
          <hdi-tooltip
            *ngIf="icon.tooltip && icon.tooltip.id === tooltip.id"
            [id]="'tooltip' + icon.tooltip.id"
            [tooltip]="clipboardTooltip ? clipboardTooltip : icon.tooltip"
            [type]="'hover'"
          ></hdi-tooltip>
        </a>
        <!-- External Link -->
        <a
          *ngIf="
            (icon.type !== 'down-to-line' && icon.target === '_blank') ||
            icon.type === 'eye' ||
            icon.type === 'envelope' ||
            icon.type === 'phone'
          "
          [attr.href]="icon.type !== 'link' ? icon.href : null"
          [attr.target]="icon.type === 'eye' ? '_blank' : icon.target"
          [title]="icon.title"
          (click)="icon.type === 'link' ? copyToClipboard(icon, $event) : null"
          (keydown)="
            icon.type === 'link' ? copyToClipboard(icon, $event) : null
          "
        >
          <hdi-icon
            [iconPrefix]="'far'"
            [iconName]="getIconName(icon.type)"
            [size]="Sizes.SMALL"
            [color]="Colors.BLACK"
          ></hdi-icon>
          <hdi-tooltip
            *ngIf="icon.tooltip && icon.tooltip.id === tooltip.id"
            [id]="'tooltip' + icon.tooltip.id"
            [tooltip]="clipboardTooltip ? clipboardTooltip : icon.tooltip"
            [type]="'hover'"
          ></hdi-tooltip>
        </a>
        <!-- If the icon type is 'down-to-line', then it is a download. And it has a download attribute -->
        <a
          *ngIf="icon.type === 'down-to-line'"
          [attr.href]="icon.href"
          [attr.target]="icon.target ?? '_blank'"
          [title]="icon.title"
          download
        >
          <hdi-icon
            [iconPrefix]="'far'"
            [iconName]="getIconName(icon.type)"
            [size]="Sizes.SMALL"
            [color]="Colors.BLACK"
          ></hdi-icon>
          <hdi-tooltip
            *ngIf="icon.tooltip && icon.tooltip.id === tooltip.id"
            [id]="'tooltip' + icon.tooltip.id"
            [tooltip]="clipboardTooltip ? clipboardTooltip : icon.tooltip"
            [type]="'hover'"
          ></hdi-tooltip>
        </a>
      </hdi-button>
    </span>
  </div>
</div>
